module.exports = __webpack_public_path__ + "static/media/symbols.33117a80.svg";